"use client";

import type { ReactNode } from "react";

import ReactDOM from "react-dom";

import { legacyUrlTo } from "@/src/app/legacyUrls";
import {
  airtableCookie,
  airtableEmbedOrigin,
} from "@/src/infrastructure/airtable/airtable";
import { useConsent } from "@/src/infrastructure/cookieconsent/consent";
import {
  googleMapsCookie,
  googleMapsEmbedOrigin,
} from "@/src/infrastructure/google-maps/googleMaps";
import {
  mondayCookie,
  mondayEmbedOrigin,
} from "@/src/infrastructure/monday/monday";
import {
  youTubeCookie,
  youTubeEmbedOrigin,
  youTubeThumbnailOrigin,
} from "@/src/infrastructure/youtube/YouTubeVideo";

export function Preconnect(): ReactNode {
  const airtableConsented = useConsent(airtableCookie);
  const googleMapsConsented = useConsent(googleMapsCookie);
  const mondayConsented = useConsent(mondayCookie);
  const youTubeConsented = useConsent(youTubeCookie);

  ReactDOM.preconnect(
    new URL(process.env["NEXT_PUBLIC_STRAPI_MEDIA_URL"]!).origin,
  );

  ReactDOM.preconnect(new URL(legacyUrlTo()).origin);

  if (airtableConsented) {
    ReactDOM.preconnect(airtableEmbedOrigin);
  }
  if (googleMapsConsented) {
    ReactDOM.preconnect(googleMapsEmbedOrigin);
  }
  if (mondayConsented) {
    ReactDOM.preconnect(mondayEmbedOrigin);
  }
  if (youTubeConsented) {
    ReactDOM.preconnect(youTubeEmbedOrigin);
    ReactDOM.preconnect(youTubeThumbnailOrigin);
  }

  return null;
}
